import type { $Fetch } from 'ofetch';
import { BaseClient } from '@shared/clients/BaseClient.ts';
import type { Logger } from '@shared/types/types';

const DEFAULT_TIMEOUT_MS = 3000;

export class DynamicEsiClient extends BaseClient {
    constructor({
        name,
        fetchClient,
        logger,
        baseURL,
        timeout = DEFAULT_TIMEOUT_MS,
    }: {
        name: string;
        fetchClient: $Fetch;
        logger: Logger;
        baseURL?: string;
        timeout?: number;
    }) {
        super(baseURL, fetchClient, logger, timeout);
        this.name = name;
    }

    private readonly name: string;

    async getHtml(url: string): Promise<string> {
        try {
            const html = await this.fetch<string, 'text'>(url, { responseType: 'text' });
            if (html?.includes('\uFFFD')) {
                this.logger.warn(`[${this.name}] Response contains non-UTF-8 characters, ignoring`);
                return '';
            }
            return html;
        } catch (err) {
            this.logger.info(err, `[${this.name}] Failed to fetch ${url}`);
            return '';
        }
    }
}
